'use strict';

const LOCATION_CHANGE_START = '@@ng/$locationChangeStart';
const LOCATION_CHANGE_SUCCESS = '@@ng/$locationChangeSuccess';

/**
 *
 * @param evt
 * @param newUrl
 * @param oldUrl
 * @param newState
 * @param oldState
 * @return {ReduxAction}
 */
export function onLocationChangeStart(evt, newUrl, oldUrl, newState, oldState) {
  return {
    type: LOCATION_CHANGE_START,
    payload: {
      evt,
      newUrl,
      oldUrl,
      newState,
      oldState,
    },
  };
}
onLocationChangeStart.TYPE = LOCATION_CHANGE_START;

/**
 *
 * @param evt
 * @param newUrl
 * @param oldUrl
 * @param newState
 * @param oldState
 * @return {ReduxAction}
 */
export function onLocationChangeSuccess(evt, newUrl, oldUrl, newState, oldState) {
  return {
    type: LOCATION_CHANGE_SUCCESS,
    payload: {
      evt,
      newUrl,
      oldUrl,
      newState,
      oldState,
    },
  };
}
onLocationChangeSuccess.TYPE = LOCATION_CHANGE_SUCCESS;



// WEBPACK FOOTER //
// ./src/js/config/actions/index.js